import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSilverstoneMinimapMarkers = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={376}
      height={375}
      fill="none"
      viewBox="0 0 376 375"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#icon-silverstone-minimap-markers_svg__a)">
        <path
          fill="url(#icon-silverstone-minimap-markers_svg__b)"
          fillOpacity={0.2}
          stroke="#fff"
          strokeOpacity={0.1}
          strokeWidth={10}
          d="M91.656 223.086c-20.72-11.997-35.175-22.38-47.2-31.635-1.545-1.431-5.236-4.566-6.464-6.226-2.24-3.026-3.458-6.575-3.458-12.116 0-4.177 1.67-8.012 3.909-10.769 2.637-3.249 6.66-5.302 9.019-6.394 4.36-2.02 11.073-6.689 17.888-12.284 3.076-2.525 7.402-6.96 11.899-11.587l.327-.336c1.99-2.047 4.009-4.124 5.963-6.082a557.968 557.968 0 0 1 5.835-5.751c2.016-1.961 3.477-3.367 4.086-4.009 2.045-2.154 1.203-4.065.602-4.88a833.979 833.979 0 0 0-4.51-6.057c-1.654-2.188-1.503-4.544 0-7.068 9.02-11.442 16.776-12.346 20.594-13.461 3.457-1.01 5.261-.337 6.464.673l8.773 7.515c23.084 19.766 57.42 49.118 59.323 50.538 2.705 2.019 4.509 4.88 5.111 10.601.601 5.721-1.203 16.491-2.556 26.25-1.353 9.76 2.556 17.332 3.458 19.015.576 1.075 6.429 9.431 10.895 15.72 2.524 3.555 4.604 6.45 5.039 6.996 1.202 1.515 6.012 7.909 7.065 11.611 1.052 3.702-2.105 4.88-3.007 5.385-.542.303-4.234 1.64-7.746 2.841-2.331.797-4.583 1.535-5.783 1.87-3.006.842-5.862 2.693-5.862 5.385 0 2.692.705 3.402 3.157 4.88 9.77 5.889 22.099 7.057 26.606 6.899 3.359-.117 6.278-3.188 8.245-5.66.851-1.069 1.524-2.027 1.977-2.585 1.174-1.445 40.668-49.355 60.279-74.039a602.292 602.292 0 0 0 2.985-3.789 590.144 590.144 0 0 0 6.098-7.928c1.659-2.202 2.824-3.801 3.093-4.269 2.91-5.048 2.803-11.293.301-15.818-1.954-3.533-5.712-4.038-7.666-4.206-1.349-.116-4.811-.337-9.32-1.01-4.679-.698-8.418-5.721-8.268-10.769.206-6.914 4.713-9.107 7.366-10.096 2.706-1.01 4.96.168 6.163.504 1.203.337 4.961 2.524 7.666 4.207 2.706 1.683 10.373 5.553 15.935 9.087 5.561 3.533 9.319 9.423 12.777 14.134 3.457 4.712 5.712 11.779 6.764 21.203 1.053 9.423 5.707 67.469 6.013 77.572.301 9.928-7.065 15.986-10.372 17.5-3.307 1.515-8.568 3.534-20.744 6.9-9.741 2.692-23.501 4.15-29.163 4.543-5.822.306-16.935.912-23.884 1.356-1.962.125-3.591.238-4.677.327-6.163.504-12.176 4.711-13.228 5.553-1.053.841-4.66 3.701-8.118 3.701-3.457 0-9.169-2.86-11.574-3.87-2.406-1.009-8.118-4.038-13.68-4.038-5.562 0-9.47 3.029-11.274 4.88-1.804 1.851-6.614 5.889-9.771 6.057-2.421.129-5.919.497-10.071-3.029-1.611-1.367-2.75-3.355-3.56-5.463-1.384-3.596-1.813-7.541-2.002-9.344-.301-2.861-3.758-5.217-8.569-7.909-4.81-2.692-37.063-22.187-40.286-24.063-3.758-2.187-15.784-9.591-28.862-17.163Z"
        />
        <path
          stroke="#CCC"
          strokeLinecap="square"
          strokeWidth={4}
          d="M89.55 104.96c-1.653-2.188-1.503-4.544 0-7.068 9.02-11.442 16.777-12.346 20.595-13.461 3.457-1.01 5.261-.337 6.464.673l8.773 7.515"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M125.383 92.62c23.083 19.766 57.419 49.117 59.322 50.537 2.706 2.019 4.51 4.88 5.111 10.601.601 5.721-1.203 16.491-2.555 26.25-1.353 9.76 2.555 17.332 3.457 19.015.576 1.075 6.429 9.431 10.895 15.72"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M213.718 233.35c-1.052-3.702-5.862-10.096-7.065-11.611-.434-.547-2.515-3.441-5.039-6.996"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M210.71 238.735c.902-.505 4.059-1.683 3.006-5.385"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M210.71 238.735c-.542.303-4.234 1.64-7.746 2.841"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M197.182 243.446c1.199-.335 3.451-1.073 5.782-1.87"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M194.476 253.711c-2.452-1.478-3.157-2.188-3.157-4.88 0-2.692 2.856-4.543 5.863-5.385"
        />
        <path
          stroke="#CCC"
          strokeLinecap="square"
          strokeWidth={4}
          d="M194.474 253.711c9.771 5.889 22.099 7.057 26.607 6.899 3.358-.117 6.277-3.188 8.244-5.66"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M229.327 254.95c.851-1.069 1.524-2.027 1.977-2.585 1.174-1.445 40.668-49.354 60.279-74.039a641.48 641.48 0 0 0 2.986-3.789"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M294.569 174.537a590.144 590.144 0 0 0 6.098-7.928"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M296.393 142.315c1.954.169 5.712.674 7.666 4.207 2.502 4.525 2.609 10.77-.301 15.818-.269.468-1.434 2.067-3.093 4.269"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M287.075 141.306c4.51.673 7.971.893 9.32 1.009"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M292.335 120.945c-1.202-.336-3.457-1.514-6.163-.505-2.653.99-7.16 3.183-7.366 10.097-.15 5.048 3.589 10.071 8.268 10.769"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M341.49 247.148c-.306-10.103-4.96-68.149-6.013-77.572-1.052-9.424-3.307-16.491-6.764-21.203-3.458-4.711-7.216-10.601-12.778-14.134-5.561-3.534-13.228-7.404-15.934-9.087-2.705-1.683-6.463-3.87-7.666-4.207"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M331.117 264.649c3.307-1.515 10.673-7.573 10.372-17.501"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M331.118 264.648c-3.307 1.515-8.568 3.534-20.744 6.9-9.741 2.692-23.501 4.15-29.163 4.543-5.822.306-16.935.912-23.884 1.356"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M257.33 277.447c-1.962.125-3.592.237-4.678.326-6.163.505-12.176 4.712-13.228 5.553-1.052.842-4.66 3.702-8.117 3.702-3.458 0-9.17-2.86-11.575-3.87-2.405-1.01-8.117-4.039-13.679-4.039-5.562 0-9.471 3.029-11.274 4.88-1.804 1.851-6.615 5.89-9.771 6.058-2.421.129-5.92.497-10.072-3.029-1.611-1.368-2.749-3.356-3.56-5.463"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M44.456 191.451c12.026 9.255 26.481 19.638 47.201 31.635 13.078 7.572 25.104 14.976 28.862 17.164 3.223 1.876 35.476 21.37 40.286 24.062 4.81 2.693 8.268 5.049 8.568 7.909.19 1.804.619 5.748 2.002 9.345"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M44.452 191.451c-1.544-1.431-5.235-4.566-6.464-6.226"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M38.442 162.34c-2.238 2.757-3.909 6.592-3.909 10.769 0 5.541 1.218 9.09 3.458 12.116"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M38.44 162.34c2.637-3.249 6.66-5.302 9.019-6.394 4.36-2.019 11.073-6.689 17.888-12.284 3.076-2.525 7.402-6.96 11.899-11.586"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M77.248 132.075c2.096-2.156 4.229-4.353 6.29-6.418a548.168 548.168 0 0 1 5.835-5.751"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M89.553 104.959a832.445 832.445 0 0 1 4.51 6.058c.601.815 1.443 2.726-.601 4.88-.61.642-2.07 2.048-4.087 4.009"
        />
        <g filter="url(#icon-silverstone-minimap-markers_svg__c)">
          <path
            fill="#fff"
            fillOpacity={0.95}
            d="m138.01 133.114 3.073 2.604 2.926-3.453-3.073-2.604zM143.862 126.208l3.073 2.604 2.926-3.453-3.073-2.604zM149.714 119.303l3.073 2.604 2.926-3.453-3.073-2.604zM155.566 112.398l3.073 2.604 2.926-3.453-3.073-2.604zM161.418 105.493l3.073 2.604 2.926-3.453-3.073-2.604z"
          />
          <path
            fill="#fff"
            fillOpacity={0.95}
            d="m144.009 132.265 3.073 2.604 2.926-3.453-3.073-2.604zM149.861 125.36l3.073 2.604 2.926-3.453-3.073-2.604zM155.713 118.455l3.073 2.604 2.926-3.453-3.073-2.604zM161.565 111.549l3.073 2.604 2.926-3.453-3.073-2.604z"
          />
          <path
            fill="#000"
            d="m141.083 135.718 3.073 2.604 2.926-3.453-3.073-2.604zM146.935 128.812l3.073 2.604 2.926-3.453-3.073-2.604zM152.787 121.907l3.073 2.604 2.926-3.453-3.073-2.604zM158.639 115.002l3.073 2.604 2.926-3.453-3.073-2.604zM164.491 108.097l3.073 2.604 2.926-3.453-3.073-2.604z"
          />
          <path
            fill="#000"
            d="m140.936 129.661 3.073 2.604 2.926-3.453-3.073-2.604zM146.788 122.756l3.073 2.604 2.926-3.453-3.073-2.604zM152.641 115.851l3.073 2.604 2.926-3.453-3.073-2.604zM158.492 108.945l3.073 2.604 2.926-3.453-3.073-2.604z"
          />
          <path
            fill="#E2645A"
            d="m148.214 80.964 17.678 2.062-12.776 15.075-4.902-17.137Zm-1.726-1.464c-.471.556-.683 1.268-.478 1.95l5.173 17.941c.379 1.403 2.147 1.628 3.183.406l13.436-15.853c1.004-1.185.523-2.93-.892-3.11l-18.577-2.124a2.208 2.208 0 0 0-1.845.79Z"
          />
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__d)">
          <rect
            width={20}
            height={20}
            x={106.5}
            y={50}
            fill="url(#icon-silverstone-minimap-markers_svg__e)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__f)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m112.634 57.076-1.836.948V56.74l2.076-1.14h1.152V64h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456V60.82l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L120.42 64h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__g)">
          <rect
            width={20}
            height={20}
            x={57.5}
            y={81}
            fill="url(#icon-silverstone-minimap-markers_svg__h)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__i)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m63.774 88.076-1.836.948V87.74l2.076-1.14h1.152V95h-1.392v-6.924Zm6.802 5.316h-4.08V91.82l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V95h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__j)">
          <rect
            width={20}
            height={20}
            x={104.5}
            y={108}
            fill="url(#icon-silverstone-minimap-markers_svg__k)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__l)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m110.616 115.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.142 5.688v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V113.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L118.498 122h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__m)">
          <rect
            width={20}
            height={20}
            x={7.5}
            y={141}
            fill="url(#icon-silverstone-minimap-markers_svg__n)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__o)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m13.516 148.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.263 5.688v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48H18.65l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L21.59 155h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__p)">
          <rect
            width={20}
            height={20}
            x={20.5}
            y={195}
            fill="url(#icon-silverstone-minimap-markers_svg__q)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__r)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m27.12 202.076-1.836.948v-1.284l2.076-1.14h1.152v8.4H27.12v-6.924Zm6.91-.048v-.228h-4.248v-1.2h5.688v1.464L32.122 209h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__s)">
          <rect
            width={20}
            height={20}
            x={201.5}
            y={117}
            fill="url(#icon-silverstone-minimap-markers_svg__t)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__u)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m207.803 124.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V131h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__v)">
          <rect
            width={20}
            height={20}
            x={153.5}
            y={170}
            fill="url(#icon-silverstone-minimap-markers_svg__w)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__x)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m160.958 177.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__y)">
          <rect
            width={20}
            height={20}
            x={215.5}
            y={212}
            fill="url(#icon-silverstone-minimap-markers_svg__z)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__A)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m221.341 219.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L229.559 226h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__B)">
          <rect
            width={20}
            height={20}
            x={167.5}
            y={222}
            fill="url(#icon-silverstone-minimap-markers_svg__C)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__D)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M174.44 234.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L179.132 236h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__E)">
          <rect
            width={20}
            height={20}
            x={243.5}
            y={244}
            fill="url(#icon-silverstone-minimap-markers_svg__F)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__G)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M250.256 256.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L255.26 258h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__H)">
          <rect
            width={20}
            height={20}
            x={268.5}
            y={147}
            fill="url(#icon-silverstone-minimap-markers_svg__I)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__J)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M279.661 154.028v-.228h-4.248v-1.2h5.688v1.464L277.753 161h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__K)">
          <rect
            width={20}
            height={20}
            x={253.5}
            y={107}
            fill="url(#icon-silverstone-minimap-markers_svg__L)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__M)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M260.409 119.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L265.221 121h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__N)">
          <rect
            width={20}
            height={20}
            x={323.5}
            y={111}
            fill="url(#icon-silverstone-minimap-markers_svg__O)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__P)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M330.389 123.764v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V116.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L335.129 125h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__Q)">
          <rect
            width={20}
            height={20}
            x={331.5}
            y={270}
            fill="url(#icon-silverstone-minimap-markers_svg__R)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__S)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M342.207 282.392h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V284h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__T)">
          <rect
            width={20}
            height={20}
            x={171.5}
            y={301}
            fill="url(#icon-silverstone-minimap-markers_svg__U)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__V)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m178.505 313.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V315h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__W)">
          <rect
            width={20}
            height={20}
            x={229.5}
            y={293}
            fill="url(#icon-silverstone-minimap-markers_svg__X)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__Y)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M236.287 305.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L241.051 307h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-silverstone-minimap-markers_svg__Z)">
          <rect
            width={20}
            height={20}
            x={134.5}
            y={274}
            fill="url(#icon-silverstone-minimap-markers_svg__aa)"
            rx={10}
          />
          <g filter="url(#icon-silverstone-minimap-markers_svg__ab)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m144.327 281.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="icon-silverstone-minimap-markers_svg__c"
          width={87.695}
          height={90.322}
          x={105.5}
          y={63}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={3}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={4} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__d"
          width={36}
          height={36}
          x={98.5}
          y={44}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__f"
          width={26.858}
          height={24.4}
          x={102.798}
          y={49.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__g"
          width={36}
          height={36}
          x={49.5}
          y={75}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__i"
          width={27.05}
          height={24.4}
          x={53.938}
          y={80.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__j"
          width={36}
          height={36}
          x={96.5}
          y={102}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__l"
          width={26.954}
          height={24.4}
          x={100.78}
          y={107.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__m"
          width={36}
          height={36}
          x={-0.5}
          y={135}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__o"
          width={27.145}
          height={24.4}
          x={3.681}
          y={140.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__p"
          width={36}
          height={36}
          x={12.5}
          y={189}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__r"
          width={26.186}
          height={24.4}
          x={17.284}
          y={194.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__s"
          width={36}
          height={36}
          x={193.5}
          y={111}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__u"
          width={26.689}
          height={24.4}
          x={197.968}
          y={116.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__v"
          width={36}
          height={36}
          x={145.5}
          y={164}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__x"
          width={23.966}
          height={24.4}
          x={151.122}
          y={169.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__y"
          width={36}
          height={36}
          x={207.5}
          y={206}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__A"
          width={27.386}
          height={24.4}
          x={211.505}
          y={211.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__B"
          width={36}
          height={36}
          x={159.5}
          y={216}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__D"
          width={22.048}
          height={24.4}
          x={166.32}
          y={221.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__E"
          width={36}
          height={36}
          x={235.5}
          y={238}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__G"
          width={22.24}
          height={24.4}
          x={242.256}
          y={243.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__H"
          width={36}
          height={36}
          x={260.5}
          y={141}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__J"
          width={21.688}
          height={24.4}
          x={267.413}
          y={146.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__K"
          width={36}
          height={36}
          x={245.5}
          y={101}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__M"
          width={22.048}
          height={24.4}
          x={252.409}
          y={106.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__N"
          width={36}
          height={36}
          x={315.5}
          y={105}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__P"
          width={21.977}
          height={24.4}
          x={322.389}
          y={110.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__Q"
          width={36}
          height={36}
          x={323.5}
          y={264}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__S"
          width={22.492}
          height={24.4}
          x={330.127}
          y={269.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__T"
          width={36}
          height={36}
          x={163.5}
          y={295}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__V"
          width={21.831}
          height={24.4}
          x={170.457}
          y={300.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__W"
          width={36}
          height={36}
          x={221.5}
          y={287}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__Y"
          width={22}
          height={24.4}
          x={228.287}
          y={292.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__Z"
          width={36}
          height={36}
          x={126.5}
          y={268}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <filter
          id="icon-silverstone-minimap-markers_svg__ab"
          width={19.227}
          height={24.4}
          x={134.491}
          y={273.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_2029"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_2029"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_2029"
            result="effect2_dropShadow_9632_2029"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_2029"
            result="shape"
          />
        </filter>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__b"
          x1={34.534}
          x2={341.5}
          y1={188.034}
          y2={188.034}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FC5BA" />
          <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__e"
          x1={126.5}
          x2={106.5}
          y1={50}
          y2={70}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__h"
          x1={77.5}
          x2={57.5}
          y1={81}
          y2={101}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__k"
          x1={124.5}
          x2={104.5}
          y1={108}
          y2={128}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__n"
          x1={27.5}
          x2={7.5}
          y1={141}
          y2={161}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__q"
          x1={40.5}
          x2={20.5}
          y1={195}
          y2={215}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__t"
          x1={221.5}
          x2={201.5}
          y1={117}
          y2={137}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__w"
          x1={173.5}
          x2={153.5}
          y1={170}
          y2={190}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__z"
          x1={235.5}
          x2={215.5}
          y1={212}
          y2={232}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__C"
          x1={187.5}
          x2={167.5}
          y1={222}
          y2={242}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__F"
          x1={263.5}
          x2={243.5}
          y1={244}
          y2={264}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__I"
          x1={288.5}
          x2={268.5}
          y1={147}
          y2={167}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__L"
          x1={273.5}
          x2={253.5}
          y1={107}
          y2={127}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__O"
          x1={343.5}
          x2={323.5}
          y1={111}
          y2={131}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__R"
          x1={351.5}
          x2={331.5}
          y1={270}
          y2={290}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__U"
          x1={191.5}
          x2={171.5}
          y1={301}
          y2={321}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__X"
          x1={249.5}
          x2={229.5}
          y1={293}
          y2={313}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-silverstone-minimap-markers_svg__aa"
          x1={154.5}
          x2={134.5}
          y1={274}
          y2={294}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <clipPath id="icon-silverstone-minimap-markers_svg__a">
          <path fill="#fff" d="M.5 0h375v375H.5z" />
        </clipPath>
      </defs>
    </svg>
  )
);
export default SvgIconSilverstoneMinimapMarkers;
